import styled from 'styled-components';

export const NotificationSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 2rem 0 0;
`;
export const LeftSection = styled.div``;
export const RightSection = styled.div``;

export const BusNotificationDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  background-image: linear-gradient(-265deg, #00c57e, #18a160);
  padding-right:${props.theme.spacing.xxlarge};
  padding-left:${props.theme.spacing.large};
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  color:${props.theme.colors.white.base};
  font-size:${props.theme.font.base};
  border-bottom-right-radius: 2rem;
  border-top-left-radius: 0.4rem;
  
`,
);

